import { useDispatch, useReduxState } from 'hooks';
import api from 'api';
import { Button } from 'components/common';

interface Props {
  id: number;
  isRead: boolean;
  updateCompletions: () => Promise<void>;
}

const MyTeamReviewCompletionsMarkReviewed = ({
  id,
  isRead,
  updateCompletions
}: Props) => {
  const { dispatch } = useDispatch();

  const {
    messages,
    pageState: { supervisor },
    supervisorUnreviewedItems,
    user
  } = useReduxState();

  const setAsReviewed = async () => {
    if (!user) return;

    try {
      await api.put(`/admin/supervisors/${user.id}/unreviewed-items/${id}`);
      await updateCompletions();

      const unreviewedItems = supervisorUnreviewedItems - 1;
      dispatch.setSupervisorUnreviewedItems(unreviewedItems);
      dispatch.updatePageState({
        supervisor: { ...supervisor, unreviewedItems }
      });
    } catch (err) {
      await dispatch.handleErrorDispatch(err);
    }
  };

  return isRead ? null : (
    <Button
      aria-label={messages.commonMarkAsReviewed}
      category="lighter"
      data-tooltip={messages.commonMarkAsReviewed}
      icon="check"
      onClick={setAsReviewed}
      size="large"
      style={{
        width: 28,
        height: 28,
        padding: 0
      }}
    />
  );
};

export default MyTeamReviewCompletionsMarkReviewed;
